export const CAROUSEL_ITEM = 'data-carousel-item';
export const CAROUSEL_ACTIVE_ITEM = 'data-carousel-active-item';
